import type { ReactNode } from 'react';
import { greeting, longDate } from './dates';

/**
 * The one bold thing on the one bold screen (PRD 6). Time-of-day greeting, the
 * family member's own name in their own color (from D1 — never hardcoded), and a
 * single honest line about the state of the house.
 */
export default function Hero({
  name,
  color,
  children,
}: {
  name: string;
  color: string | null;
  children?: ReactNode;
}) {
  return (
    <section className="relative overflow-hidden rounded-card border border-border bg-gradient-to-br from-honey-soft via-canvas to-sage-soft px-5 py-8 sm:px-9 sm:py-11">
      {/* Soft light in the corner — pure decoration, kept out of the a11y tree. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -right-16 h-64 w-64 rounded-full opacity-60 blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.9), transparent 70%)' }}
      />

      <div className="relative">
        <p className="text-sm font-medium tracking-wide text-ink-soft">{longDate()}</p>
        <h1 className="mt-1 font-display text-3xl leading-tight font-semibold text-ink sm:text-5xl">
          {greeting()},{' '}
          <span style={{ color: color ?? 'var(--color-sage)' }}>{name}</span>
        </h1>
        {children && <div className="mt-3 max-w-xl text-base text-ink-soft">{children}</div>}
      </div>
    </section>
  );
}
